import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SecureStorageService } from '../../services/secure-storage.service';

// Liste des routes qui ne devraient pas rediriger même avec un token
const noRedirectRoutes = [
  '/explore',
  '/sendmail-info',
  '/celebrities/domaines',
  '/verify-email',
  '/',
  '/#/'
];

export const AuthRedirectGuard = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const secureStorage = inject(SecureStorageService);
  const token = secureStorage.getItem<string>('token');
  const destinationUrl = state.url;

  // Si c'est une route sans redirection, permettre l'accès
  if (noRedirectRoutes.some(route => destinationUrl === route || destinationUrl.startsWith(route + '/'))) {
    return true;
  }

  // Pour la page de login, rediriger vers l'accueil si déjà connecté
  if (token && destinationUrl.includes('/auth/login')) {
    router.navigate(['/']);
    return false;
  }

  return true;
}; 